import { useEffect, useState } from "react";
import { gsap } from "gsap";
import { useInView } from "react-intersection-observer";

import useWindowDimensions from "../hooks/useWindowDimensions";

const Terms = () => {
  const { width } = useWindowDimensions();

  const [animated, setAnimated] = useState(false);
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView && !animated) {
      let tl = gsap.timeline();

      tl.from("#terms-h", {
        stagger: 0.1,
        opacity: 0,
        delay: 0.25,
        transform: "scale(0.5) rotate(-5deg)",
      });

      tl.from("#terms-div1", {
        stagger: 0.1,
        opacity: 0,
        y: 50,
      });

      tl.from("#terms-div2", {
        stagger: 0.1,
        opacity: 0,
        y: 50,
      });

      setAnimated(!animated);
    }
  }, [inView]);

  useEffect(() => {
    document.getElementsByTagName("body")[0].style.backgroundImage = "none";
  }, []);

  return (
    <div
      ref={ref}
      id="terms"
      className="min-vh-100 d-flex flex-column justify-content-center align-items-center text-center"
    >
      <div className="container">
        <div
          id="terms-h"
          style={{
            fontSize: width > 900 ? 70 : 42,
            color: "var(--primary)",
          }}
        >
          <h1 className="primary-h">
            Terms of Sale for <br />
            Gutter Bats Planet
          </h1>
        </div>
        <br />
        <div id="terms-div1">
          <p
            className="primary-p"
            style={{ fontSize: 16, lineHeight: 1.75, textAlign: "left" }}
          >
            Please read these Terms of Sale for a user ("You" or "Your" or
            "User") as it contains important information about Your legal
            rights, remedies and obligations. By accessing or using the website
            https://www.gutterbatsplanet.com ("Website or "platform"), You agree
            to comply with and be bound by this Agreement. This Agreement
            constitutes a legally binding agreement between You and Blockchain
            Media ("Gutter Bats Planet"), a private limited company having its
            registered office at 20 Penn Mart Shopping Ctr, PMB 500, New Castle,
            DE 19720 governing Your access to and use of the Website including
            any subdomains thereof.
            <br />
            <br />
            The Website contains a collection of digital artworks (NFTs as
            defined hereinafter) running on the Ethereum network. This Website
            is only an interface allowing participants to exchange digital
            collectibles. If any provision of these Terms of Service or any
            future changes are unacceptable to you, do not use or continue to
            use the Website and do not link your Ethereum Wallets to our
            platform. Your continued use of the Website following the posting of
            any notice of any change to these Terms of Service shall constitute
            your acceptance and agreement to such change.
          </p>
        </div>
        <div
          id="terms-div2"
          style={{
            background: "rgba(var(--dark-rgb), 0.5)",
            borderRadius: 20,
            padding: 20,
          }}
        >
          <p style={{ fontSize: 16, lineHeight: 1.75, textAlign: "left" }}>
            <ol>
              <li style={{ fontSize: 18 }}>
                <strong>DEFINITIONS</strong>
              </li>
              <ol type="a">
                <li>
                  <strong>"Art"</strong> means any art, design, and drawings
                  that may be associated with an NFT that you Own.
                </li>
                <li>
                  <strong>"NFT"</strong> means any blockchain-tracked,
                  non-fungible token, such as those conforming to the ERC-721
                  standard.
                </li>
                <li>
                  <strong>"NFT Owner"</strong> means a User that has purchased
                  an NFT created by Gutter Bats Planet..
                </li>
                <li>
                  <strong>"Own"</strong> means, with respect to an NFT, an NFT
                  that you have purchased or otherwise rightfully acquired from
                  a legitimate source, where proof of such purchase is recorded
                  on the relevant blockchain.
                </li>
                <li>
                  <strong>"Purchased NFT"</strong> means an NFT that you Own.
                </li>
                <li>
                  <strong>"Qualifying Transaction"</strong> means a transaction
                  made by a NFT Owner to sell their Purchased NFT on a
                  consumer-to-consumer basis (C2C) or on any secondary
                  marketplace, where proof of such purchase is recorded on the
                  relevant blockchain.
                </li>
                <li>
                  <strong>"Royalty"</strong> means the amount payable by the NFT
                  Owner to Gutter Bats Planet on each Qualifying Transaction.
                </li>
              </ol>
              <br />
              <li>
                <strong>OBLIGATONS</strong>
                <p>
                  By accessing the Website, linking your Ethereum wallets and/or
                  purchasing an NFT from <strong>Gutter Bats Planet</strong>,
                  you agree to be bound by the following:
                  <br />
                  <br />
                  2.1 You must be at least thirteen (13) years to access and use
                  the platform; provided, if you are between the ages of
                  thirteen (13) and eighteen (18) years old (or any greater age
                  required to be deemed to have reached the age of majority
                  under the applicable law of the state or jurisdiction of your
                  primary residence) you may only access and use the platform
                  with the prior permission of your parent or legal guardian,
                  and you represent and warrant to us that you have such
                  permission and that your parent or legal guardian has reviewed
                  and discussed these terms of service with you. Since certain
                  content made available on the platform may not be suitable for
                  minors, we recommend that parents or legal guardians who
                  permit their child to access and use the website to supervise
                  such child’s activity, including, without limitation, any
                  engagement with any other user thereon.
                  <br />
                  <br />
                  2.2 You warrant that the purchase of any NFT from the Website
                  will not amount to:
                  <br />
                  <br />
                  a. breach of any agreements with any third parties,
                  <br />
                  b. breach of any agreements with banks or financial
                  institutions, or any other form of agreement,
                  <br />
                  c. breach of any applicable laws of your jurisdiction,
                  <br />
                  d. an infringement, misappropriation or violation of a third
                  party’s patent, copyright, trademark, trade secret, moral
                  rights or other proprietary or intellectual property rights,
                  or rights of publicity or privacy, or result in the violation
                  of any applicable law or regulation.
                  <br />
                  <br />
                  2.3 You represent and warrant that you understand the
                  cryptocurrencies and NFT market, along with associated risks,
                  expenses, and fee. To initiate certain transactions on the
                  Website, a User must voluntarily invoke one or more smart
                  contract operations from an Ethereum Wallet. All such
                  transactions on the Website, including sale or purchases of
                  NFTs are initiated though one or more smart contracts at the
                  sole discretion and at the complete risk of the Users. The
                  smart contracts are configured to facilitate the execution of
                  a sale or transfer an NFT. The User acknowledges the risk of
                  smart contracts and agrees to be bound by the outcome of any
                  smart contract operation by invoking, calling, requesting, or
                  otherwise engaging with the smart contract, whether or not the
                  smart contract behaves as per the User’s expectations. You
                  acknowledge and agree that there are risks associated with
                  purchasing and holding NFTs and using blockchain technology.
                  These including, but are not limited to, risk of losing access
                  to NFT due to loss of private key(s), custodial error or
                  purchaser error, risk of mining or blockchain attacks, risk of
                  hacking and security weaknesses, risk of unfavourable
                  regulatory intervention in one or more jurisdictions, risks
                  related to token taxation, risk of personal information
                  disclosure, risk of uninsured losses, unanticipated risks, and
                  volatility risks.
                  <br />
                  <br />
                  2.4 You understand that the NFT(s) will be purchased with
                  Ethereum and that Gutter Bats Planet has no control over gas
                  fees collected by Ethereum miners. You also understand that
                  Gutter Bats Planet does not have the ability to reverse
                  Ethereum transactions.
                  <br />
                  <br />
                  2.5 You are entirely responsible for the safety and management
                  of your own private Ethereum wallets and validating all
                  transactions and contracts generated by this website before
                  approval. Furthermore, as the smart contract runs on the
                  Ethereum network, there is no ability to undo, reverse, or
                  restore any transactions.
                </p>
              </li>
              <li style={{ fontSize: 18 }}>
                <strong>OWNERSHIP & ROYALTY</strong>
                <p>
                  3.1 Your ownership of any Purchased NFT issued by Gutter Bats
                  Planet is governed by a smart contract on the Ethereum
                  Network, which cannot be reversed or modified in any way
                  whatsoever.
                  <br />
                  <br />
                  3.2 Subject to your continued compliance with the terms of
                  this License, Gutter Bats Planet grants you a worldwide,
                  exclusive, transferable, license to use, copy, and display the
                  Art for your Purchased NFTs, subject to Royalties as detailed
                  in clause 3.5 hereinbelow, solely for the following purposes:
                  (i) for your own personal use; (ii) commercial use subject to
                  clause 3.3 herein below; (iii) as part of a marketplace that
                  permits the purchase and sale of your Purchased NFTs, provided
                  that the marketplace cryptographically verifies each NFT
                  owner’s rights to display the art for their Purchased NFTs to
                  ensure that only the actual owner can display the Art; or (iv)
                  as part of a third party website or application that permits
                  the inclusion, involvement, or participation of your NFTs,
                  provided that the website/application cryptographically
                  verifies each NFT owner’s rights to display the Art for their
                  Purchased NFTs to ensure that only the actual owner can
                  display the Art, and provided that the Art is no longer
                  visible once the owner of the purchased NFT leaves the
                  website/application.
                  <br />
                  <br />
                  3.3 Subject to your continued compliance with the terms of
                  this License, Gutter Bats Planet grants you a limited,
                  worldwide, exclusive, transferable license to use, copy, and
                  display the Art for your Purchased NFTs for the purpose of
                  commercializing your own merchandise that includes, contains,
                  or consists of the Art for your Purchased NFTs (
                  <strong>“Commercial Use”</strong>). For the sake of clarity,
                  nothing in this section will be deemed to restrict you from
                  (i) owning or operating a marketplace that permits the use and
                  sale of NFTs generally, provided that the marketplace
                  cryptographically verifies each NFT owner’s rights to display
                  the Art for their purchased NFTs to ensure that only the
                  actual owner can display the Art; (ii) owning or operating a
                  third party website or application that permits the inclusion,
                  involvement, or participation of NFTs generally, provided that
                  the third party website or application cryptographically
                  verifies each NFT owner’s rights to display the Art for their
                  Purchased NFTs to ensure that only the actual owner can
                  display the Art, and provided that the Art is no longer
                  visible once the owner of the purchased NFT leaves the
                  website/application.
                  <br />
                  <br />
                  3.4 The license granted applies only to the extent that you
                  continue to own the applicable Purchased NFT. If at any time
                  you sell, trade, donate, give away, transfer, or otherwise
                  dispose of your Purchased NFT for any reason, the license
                  granted in this section will immediately expire with respect
                  to those Purchased NFTs without the requirement of notice, and
                  you will have no further rights in or to the Art for those
                  NFTs.
                  <br />
                  <br />
                  3.5 In consideration for the rights granted to each User under
                  this Agreement, Gutter Bats Planet shall be entitled to
                  receive a Royalty of 5% of the value of each Qualifying
                  Transaction.
                </p>
              </li>
              <li style={{ fontSize: 18 }}>
                <strong>DIVISION OF ROYALTIES</strong>
                <p>
                  4.1 Gutter Bats Planet has the sole discretion to decide how
                  to distribute the Royalty within the network of Gutter Bats
                  Planet NFT Owners or the community, which shall be
                  communicated to the NFT Owners and community from time to
                  time.
                  <br />
                  <br />
                  4.2 Gutter Bats Planet may in its sole discretion at any point
                  of time in the future, in its sole discretion, decide not to
                  levy any Royalty.
                </p>
              </li>
              <li style={{ fontSize: 18 }}>
                <strong>DISCLAIMER OF LIABILITY</strong>
                <p>
                  You hereby release and forever discharge Gutter Bats Planet,
                  its members, managers, subsidiaries, affiliates, licensors,
                  partners in promotions or other business, or any of such
                  parties respective agents, employees, officers, directors,
                  managers, members, vendors, third party licensors, corporate
                  partners, participants successors and assigns (collectively
                  the “Company Parties”) from, and hereby waive and relinquish,
                  each and every past, present and future dispute, claim,
                  controversy, demand, right, obligation, liability, action and
                  cause of action of every kind and nature (including personal
                  injuries, death, and property damage), that has arisen or
                  arises directly or indirectly out of, or that relates directly
                  or indirectly to, the Website (including any interactions
                  with, or act or omission of, other Users of the Website or any
                  third party links, advertisements or other content).
                  <br />
                  <br />
                  TO THE EXTENT APPLICABLE, YOU HEREBY WAIVE THE PROTECTIONS OF
                  CALIFORNIA CIVIL CODE § 1542 (AND ANY ANALOGOUS LAW IN ANY
                  OTHER APPLICABLE JURISDICTION) WHICH SAYS: “A GENERAL RELEASE
                  DOES NOT EXTEND TO CLAIMS WHICH THE CREDITOR DOES NOT KNOW OR
                  SUSPECT TO EXIST IN HIS OR HER FAVOR AT THE TIME OF EXECUTING
                  THE RELEASE, WHICH IF KNOWN BY HIM OR HER MUST HAVE MATERIALLY
                  AFFECTED HIS OR HER SETTLEMENT WITH THE DEBTOR.” YOUR USE OF
                  THE WEBSITE IS ENTIRELY AT YOUR OWN RISK. THE WESBITE IS
                  PROVIDED ON AN “AS IS” BASIS WITHOUT WARRANTIES OF ANY KIND,
                  EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO,
                  WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
                  PURPOSE AND NONINFRINGEMENT. Gutter Bats Planet MAKES NO
                  WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY, CURRENTNESS,
                  COMPLETENESS OR RELIABILITY OF ANY CONTENT PROVIDED THROUGH
                  THE WEBSITE OR THIRD-PARTY CONTENT LINKED TO THE WEBSITE AND
                  ASSUMES NO LIABILITY OR RESPONSIBILITY FOR ANY (I) ERRORS,
                  MISTAKES, OR INACCURACIES OF CONTENT, (II) PERSONAL INJURY OR
                  PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR
                  ACCESS TO AND USE OF THE WEBSITE, (III) ANY UNAUTHORIZED
                  ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL
                  PERSONAL INFORMATION STORED THEREIN. Gutter Bats Planet DOES
                  NOT WARRANT, ENDORSE, GUARANTEE OR ASSUME RESPONSIBILITY FOR
                  ANY SERVICE ADVERTISED OR OFFERED BY A THIRD-PARTY THROUGH THE
                  WEBSITE OR ANY HYPERLINK OR FEATURED IN ANY BANNER OR OTHER
                  ADVERTISING AND Gutter Bats Planet WILL NOT BE A PARTY TO OR
                  IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION
                  BETWEEN YOU AND THIRDPARTY PROVIDERS OF PRODUCTS OR SERVICES,
                  OTHER THAN AS PROVIDED HEREIN. AS WITH THE PURCHASE OF A
                  PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT,
                  YOU SHOULD USE YOUR BEST JUDGMENT AND EXERCISE CAUTION WHERE
                  APPROPRIATE. WITHOUT LIMITING THE FOREGOING, NEITHER GUTTER
                  BATS PLANET NOR ITS AFFILIATES OR LICENSORS WARRANT THAT
                  ACCESS TO THE WEBSITE WILL BE UNINTERRUPTED OR THAT THE
                  WEBSITE WILL BE ERROR-FREE, OR THAT DEFECTS WILL BE CORRECTED
                  OR THAT IT WILL ALWAYS BE ACCESSIBLE; NOR DO THEY MAKE ANY
                  WARRANTY AS TO THE RESULTS THAT MAY BE OBTAINED FROM THE USE
                  OF THE WEBSITE, OR AS TO THE TIMELINESS, ACCURACY,
                  RELIABILITY, COMPLETENESS OR CONTENT OF ANY CONTENT,
                  INFORMATION OR MATERIALS PROVIDED THROUGH OR IN CONNECTION
                  WITH THE USE OF THE WEBSITE. NEITHER GUTTER BATS PLANET NOR
                  ITS AFFILIATES OR LICENSORS IS RESPONSIBLE FOR THE CONDUCT,
                  WHETHER ONLINE OR OFFLINE, OF ANY USER. NEITHER GUTTER BATS
                  PLANET NOR ITS AFFILIATES OR LICENSORS WARRANT THAT THE GUTTER
                  BATS PLANET IS FREE FROM VIRUSES, WORMS, TROJAN HORSES, OR
                  OTHER HARMFUL COMPONENTS. COMPANY AND ITS AFFILIATES AND
                  LICENSORS CANNOT AND DO NOT GUARANTEE THAT ANY PERSONAL
                  INFORMATION SUPPLIED BY YOU WILL NOT BE MISAPPROPRIATED,
                  INTERCEPTED, DELETED, DESTROYED OR USED BY OTHERS. YOU
                  ACKNOWLEDGE AND AGREE THAT GUTTER BATS PLANET IS ONLY WILLING
                  TO PROVIDE THE WEBSITE IF YOU AGREE TO CERTAIN LIMITATIONS OF
                  OUR LIABILITY TO YOU AND THIRD PARTIES. THEREFORE, YOU AGREE
                  NOT TO HOLD COMPANY PARTIES LIABLE FOR ANY DAMAGE, SUITS,
                  CLAIMS, AND/OR CONTROVERSIES (COLLECTIVELY, “LIABILITIES”)
                  THAT HAVE ARISEN OR MAY ARISE, WHETHER KNOWN OR UNKNOWN,
                  RELATING TO YOUR OR ANY OTHER PARTY’S USE OF OR INABILITY TO
                  USE THE PLATFORM, INCLUDING WITHOUT LIMITATION ANY LIABILITIES
                  ARISING IN CONNECTION WITH THE CONDUCT, ACT OR OMISSION OF ANY
                  USER (INCLUDING WITHOUT LIMITATION STALKING, HARASSMENT THAT
                  IS SEXUAL OR OTHERWISE, ACTS OF PHYSICAL VIOLENCE, AND
                  DESTRUCTION OF PERSONAL PROPERTY), ANY DISPUTE WITH ANY USER,
                  ANY INSTRUCTION, ADVICE, ACT, OR SERVICE PROVIDED BY GUTTER
                  BATS PLANET OR ITS AFFILIATES OR LICENSORS AND ANY DESTRUCTION
                  OF YOUR INFORMATION. UNDER NO CIRCUMSTANCES WILL ANY COMPANY
                  PARTIES BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
                  CONSEQUENTIAL, SPECIAL OR EXEMPLARY DAMAGES ARISING IN
                  CONNECTION WITH YOUR USE OF OR INABILITY TO USE THE WEBSITE,
                  EVEN IF ADVISED OF THE POSSIBILITY OF THE SAME. SOME STATES DO
                  NOT ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL OR
                  CONSEQUENTIAL DAMAGES, SO THE ABOVE LIMITATIONS MAY NOT APPLY
                  TO YOU. IF, NOTWITHSTANDING THE FOREGOING EXCLUSIONS, IT IS
                  DETERMINED THAT ANY COMPANY PARTY IS LIABLE FOR DAMAGES, IN NO
                  EVENT WILL THE AGGREGATE LIABILITY, WHETHER ARISING IN
                  CONTRACT, TORT, STRICT LIABILITY OR OTHERWISE, EXCEED ONE
                  HUNDRED U.S. DOLLARS ($100.00).
                  <br />
                  <br />
                  Certain transactions on the Website, including but not limited
                  to primary sales, secondary market sales, listings, offers,
                  bids, acceptances, and other operations through the Website
                  utilize experimental smart contract and blockchain technology,
                  including non-fungible tokens, cryptocurrencies, consensus
                  algorithms, and decentralized or peer-to-peer networks and
                  systems. Users acknowledge and agree that such technologies
                  are experimental, speculative, and inherently risky. Users
                  acknowledge and agree that the NFTs may be subject to bugs,
                  malfunctions, timing errors, hacking and theft, or changes to
                  the protocol rules of the Ethereum blockchain (i.e., “forks”),
                  which can adversely affect the smart contracts and may expose
                  you to a risk of total loss, forfeiture of your digital
                  currency or NFTs, or lost opportunities to buy or sell NFTs.
                  We assume no liability or responsibility for any such smart
                  contract or related failures, risks, or uncertainties.
                </p>
              </li>
              <li style={{ fontSize: 18 }}>
                <strong>CONTACT INFORMATION</strong>
                <p>
                  In case of any questions, queries, suggestions or complaints,
                  please reach us at:{" "}
                  <a
                    href="mailto:contact@gutterbats.com"
                    style={{ color: "var(--primary)", cursor: "pointer" }}
                  >
                    contact@gutterbats.com
                  </a>
                </p>
              </li>
            </ol>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
